module.exports = __webpack_public_path__ + "img/img4.4b9bc80d.png";